<template>
  <b-navbar toggleable="lg" type="dark" variant="info" class="header-static">
    <b-navbar-brand class="d-flex">
      <!-- <img
        src="../../../../assets/Img/icons/menu.svg"
        @click="visibleLeft = true"
        class="me-2 icon-size"
      /> -->
      <Sidebar class="header-right-sidebar" v-model:visible="visibleLeft" :baseZIndex="10000">
        <template #header>
          <div>
            <i class="pi pi-times pt-3" style="font-size: 1.5rem; color: #ffffff" @click="closesidebar()"></i>
          </div>
        </template>
        <!-- <ul class="my-3">
          <li class="s-list" @click="masters()">
            <div class="d-flex align-items-center">
              <img
                class="list-icon"
                src="../../../../assets/Img/icons/dashboard.svg"
              /><span>Dashboard</span>
            </div>
            <div>
              <i class="pi pi-angle-right"></i>
            </div>
          </li>
          <li class="s-list-menu sidebar-list">
            <b-button v-b-toggle.collapse-1 variant="primary">
              <div class="d-flex align-items-center">
                <img
                  class="list-icon"
                  src="../../../../assets/Img/icons/my-store.svg"
                /><span>My Stores</span>
              </div>
              <div><i class="pi pi-angle-up"></i></div>
            </b-button>
            <b-collapse id="collapse-1" class="mt-2">
              <b-button v-b-toggle.collapse-1-inner size="sm">
                <div class="d-flex align-items-center">
                  <img
                    class="list-icon"
                    src="../../../../assets/Img/icons/main-store.svg"
                  /><span>Main Store</span>
                </div>
                <div><i class="pi pi-angle-up"></i></div>
              </b-button>
              <b-collapse id="collapse-1-inner" class="mt-2">
                <ul v-for="items in MainStoreList">
                  <li
                    class="d-flex align-items-center justify-content-between"
                    @click="navigate(items['Id'], 1)"
                  >
                    <span>{{ items["Name"] }}</span>
                  </li>
                </ul>
              </b-collapse>
              <b-button v-b-toggle.collapse-2-inner size="sm">
                <div class="d-flex align-items-center">
                  <img
                    class="list-icon"
                    src="../../../../assets/Img/icons/sub-store.svg"
                  /><span>Sub Store</span>
                </div>
                <div><i class="pi pi-angle-up"></i></div>
              </b-button>
              <b-collapse id="collapse-2-inner" class="mt-2">
                <ul v-for="items in SubStoreList">
                  <li
                    class="d-flex align-items-center justify-content-between"
                    @click="navigate(items['Id'], 2)"
                  >
                    <span>{{ items["Name"] }}</span>
                  </li>
                </ul>
              </b-collapse>
              <b-button v-b-toggle.collapse-3-inner size="sm">
                <div class="d-flex align-items-center">
                  <img
                    class="list-icon"
                    src="../../../../assets/Img/icons/department-store.svg"
                  /><span>Department Store</span>
                </div>
                <div><i class="pi pi-angle-up"></i></div>
              </b-button>
              <b-collapse id="collapse-3-inner" class="mt-2">
                <ul v-for="items in DepartmentStoreList">
                  <li
                    class="d-flex align-items-center justify-content-between"
                    @click="navigate(items['Id'], 3)"
                  >
                    <span>{{ items["Name"] }}</span>
                  </li>
                </ul>
              </b-collapse>
            </b-collapse>
          </li>
          <li class="s-list" @click="masters()">
            <div class="d-flex align-items-center">
              <img
                class="list-icon"
                src="../../../../assets/Img/icons/reports.svg"
              /><span>Reports</span>
            </div>
            <div>
              <i class="pi pi-angle-right"></i>
            </div>
          </li>
          <li class="s-list" @click="masters()">
            <div class="d-flex align-items-center">
              <img class="list-icon" src="../../../../assets/Img/icons/GRN.svg" /><span
                >Masters</span
              >
            </div>
            <div>
              <i class="pi pi-angle-right"></i>
            </div>
          </li>
          <li class="s-list" @click="masters()">
            <div class="d-flex align-items-center">
              <img class="list-icon" src="../../../../assets/Img/icons/User.svg" /><span
                >Users</span
              >
            </div>
            <div>
              <i class="pi pi-angle-right"></i>
            </div>
          </li>
          <li class="s-list" @click="routeto()">
            <div class="d-flex align-items-center">
              <img class="list-icon" src="../../../../assets/Img/icons/User.svg" /><span
                >Billing</span
              >
            </div>
            <div>
              <i class="pi pi-angle-right"></i>
            </div>
          </li>
        </ul> -->
      </Sidebar>
    </b-navbar-brand>
    <!-- <StoreDropDown /> -->
    <!-- <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
    <b-collapse id="nav-collapse" is-nav> -->
    <div class="ms-auto inventorysettings gap-3">
      <div class="entitylistbg" @click="entitytoggle" aria-haspopup="true" aria-controls="entity_menu">
        <span> Work List </span>
        <span>
          <Badge severity="warning">{{ pendingrequestcount }}</Badge>
        </span>
      </div>
      <Menu ref="entitymenu" id="entity_menu" :popup="true">
        <template #start>
          <div class="entitymenu_bg">
            <div v-for="items in entityitems">
              <div @click="poapprovaltablecall(items['EntityId'])">
                <p>{{ items["Name"] }}</p>
                <Badge severity="warning">{{ items["ListCount"] }}</Badge>
              </div>
            </div>
          </div>
        </template>
      </Menu>
      <div @click="$router.push({ path: '/codeTemplate' })">
        <img src="../../../../assets/Img/icons/codetemplateimg.svg" class="inventory-header-images" />
      </div>
      <div>
        <img src="../../../../assets/Img/icons/apps.svg" class="inventory-header-images mx-4"
          style="width: 24px !important;" @click="ModuleSwitcherpopup = true" />
      </div>
      <div class="localedropdown me-0">
        <Dropdown v-model="$i18n.locale" :options="$i18n.availableLocales.map((locale) => locale)" />
      </div>
      <div class="profile">
        <div class="flex justify-content-center">
          <Avatar :label="ProfileData.UserNameFirstLetter" class="avatar" @click="toggle" aria-haspopup="true"
            aria-controls="overlay_menu" style="background-color: rgb(193, 223, 255); color: #000" />

        </div>
      </div>
      <Dialog v-model:visible="Changepasswordpopup" modal header="Change Password" :style="{ width: '50vw' }"
        @after-hide="IsClear">
        <b-container fluid>
          <b-form @submit.prevent="IsStoreSubmit">
            <b-row class="mb-4">
              <b-col lg="8" md="8" sm="12" cols="12">
                <div class="field mb-0 position-relative">
                  <div class="blue-txt pwd-icon" @click="showhide()">
                    <i v-if="showpass == true" class="pi pi-eye-slash"></i>
                    <i v-else class="pi pi-eye"></i>
                  </div>
                  <TextField :txttype="showtxt" v-model="ChangePasswordObjVal.newpassword" placeholder=" " clearable
                    name="New Password" label="New Password" :rules="{ required: true, alphanumeric: true }"
                    id="New Password" :required-icon="true" />
                </div>
              </b-col>
            </b-row>
            <b-row>
              <b-col lg="8" md="8" sm="12" cols="12">
                <div class="field mb-0 position-relative">
                  <div class="blue-txt pwd-icon" @click="confirmshowhide()">
                    <i v-if="showconfpass == true" class="pi pi-eye-slash"></i>
                    <i v-else class="pi pi-eye"></i>
                  </div>
                  <TextField :txttype="showConfirmtxt" v-model="ChangePasswordObjVal.confirmpassword" placeholder=" "
                    clearable name="Confirm Password" label="Confirm Password"
                    :rules="{ required: true, alphanumeric: true }" id="Confirm Password" :required-icon="true" />
                  <p v-if="showError" class="err_msg_style">
                    Password Must Be Same
                  </p>
                </div>
              </b-col>
            </b-row>
            <b-row>
              <b-col class="d-flex flex-row-reverse">
                <AddButton btnname="Save" type="submit" />
              </b-col>
            </b-row>
          </b-form>
        </b-container>
      </Dialog>
    </div>
    <!-- </b-collapse> -->
  </b-navbar>
  <RouterView />
  <UpdatedSuccessfully :visible="updatepop" @ok="closetrigger()" />
  <!-- <Menu ref="entitymenu" id="entity_menu" :popup="true">
    <template v-slot:item="{ item }">
      <div class="entitymenu_bg">
        <div v-for="items in entityitems">
          <div @click="poapprovaltablecall(items.EntityId)">
            <p>{{ items["Name"] }}</p>
            <Badge severity="warning">{{ items["ListCount"] }}</Badge>
          </div>
        </div>
      </div>
    </template>
  </Menu> -->

  <Menu ref="menu" id="overlay_menu" :model="items" :popup="true" class="profilemenu">
    <template v-slot:start>
      <div class="flex flex-column align menuhead">
        <p class="menu-heading1">{{ ProfileData.UserName }}</p>
        <span class="light-txt" style="color: coral">{{
          ProfileData.RoleName
        }}</span>
        |
        <span class="light-txt">{{ ProfileData.phoneNumber }}</span>
        <b-row v-if="roleid != 1">
          <b-col>
            <div class="field pt-2 mb-0">
              <Dropdown v-model="SelectedBranchId" :options="BranchDropDown.BranchOption" optionLabel="BranchName"
                placeholder="Choose Branch" @change="BranchOnChange" />
            </div>
          </b-col>
        </b-row>
        <b-row v-if="roleid != 1">
          <b-col>
            <div class="field pt-2 mb-0">
              <Dropdown v-model="SelectedRoleId" :options="RoleDropDown.RoleOption" optionLabel="RoleName"
                placeholder="Choose Role" @change="RoleOnchange" />
            </div>
          </b-col>
        </b-row>
        <p class="d-flex flex-row-reverse blue-small-txt" @click="Changepasswordpopup = true">
          Change Password
        </p>
      </div>
    </template>
    <template v-slot:end>
      <button class="w-full p-link flex align-items-center text-color hover:surface-200 border-noround">
        <i class="pi pi-sign-out" />
        <span @click="LogOut()">Log Out</span>
      </button>
    </template>
  </Menu>
  <ModuleSwitcher v-model:visible="ModuleSwitcherpopup" :modules="modules" :loading="moduleLoading"
    :error="moduleError" />
</template>

<script lang="ts">
import { computed, defineComponent, ref, reactive, onMounted } from "vue";
import { value } from "dom7";
import { useRoute, useRouter, Router, routeLocationKey } from "vue-router";
// import commonservice from "../../../../modules/Inventory/Service/StoreService";
import CustomDropDown from "../../../../components/FormComponents/Dropdown.vue";
import LoginService from "../../../../modules/userManagement/Service/LoginService";
//import EntityMasterservice from "../../../../modules/Inventory/Service/EntityMasterService";
import EntityMasterservice from "../../../../modules/userManagement/Service/EntityMaster";

import TextField from "../../../../components/FormComponents/TextInput.vue";
import { useForm } from "vee-validate";
import { useI18n } from 'vue-i18n';

import PasswordService from "../../../userManagement/Service/PasswordService";
import UpdatedSuccessfully from "../../../../components/FormComponents/UpdatedSuccessfully.vue";
import ApprovalHistory from "../../../../modules/userManagement/Service/ApprovalHistory";
import ModuleSwitcher from "../../../../components/common/ModuleSwitcher.vue";
import ModuleMaster from "../../Service/ModuleMaster";
export default defineComponent({
  components: {
    CustomDropDown,
    TextField,
    UpdatedSuccessfully,
    ModuleSwitcher
  },
  setup() {
    debugger;

    const { handleSubmit, errors, resetForm, resetField } = useForm();
    const Changepasswordpopup = ref(false);
    const updatepop = ref(false);
    const ModuleSwitcherpopup = ref(false);

    //get local storage session data
    let SessionUserData = localStorage.getItem("UsersData");
    let usersData;
    if (SessionUserData !== null) {
      usersData = JSON.parse(SessionUserData);
    }

    let SessionRolesData = localStorage.getItem("RolesData");
    let rolesData;
    if (SessionRolesData !== null) {
      rolesData = JSON.parse(SessionRolesData);
    }
    //

    let roleid = ref();
    let DeptRoleMapId = ref();

    onMounted(() => {
      roleid.value = rolesData.RoleId == null ? 0 : rolesData.RoleId;
      DeptRoleMapId.value =
        rolesData.DeptRoleMapId == null ? 0 : rolesData.DeptRoleMapId;
      LoadProfile();
      LoadProfileBranches();
      LoadprofileRoles();
      IsShow();
      LoadWorkList();
      loadAvailableModules();
    });

    const menu = ref();
    const entitymenu = ref();
    let name = ref("");
    const mystore = ref();

    const items = ref([{ separator: true }]);
    const entityitems: any = ref([]);
    const entitytoggle = (event) => {
      entitymenu.value.toggle(event);
    };
    const toggle = (event) => {
      menu.value.toggle(event);
    };
    const mystoretoggle = (event) => {
      mystore.value.toggle(event);
    };
    const router = useRouter();
    const requestform = {
      requestId: "REQ00003",
      DocId: "1089",
      fromStoreId: 177,
      toStoreId: 172,
      fromStoreName: "",
      toStoreName: "",
      issueId: "",
      issueReturnId: "",
    };
    const closesidebar = () => {
      visibleLeft.value = false;
    };
    function masters() {
      visibleLeft.value = false;
      router.push("/Masters");
    }
    function routeto() {
      visibleLeft.value = false;

      router.push({
        path: "/dashboard",
      });
    }
    const visibleLeft = ref(false);
    const valueRef = ref("");
    const active = ref(false);

    const listed = ["2", "3"];

    // async function LogOut() {
    //   debugger;
    //   localStorage.clear();
    //   router.push({
    //     path: "/login",
    //   });
    // }


    async function LogOut() {
      debugger;

      // Check if we came from MOPUI (cross-app navigation)
      const sourceApp = localStorage.getItem('SourceApp');
      const crossAppNavigation = localStorage.getItem('CrossAppNavigation');

      // Clear MoceroUI localStorage first
      localStorage.clear();

      if (sourceApp === 'MOPUI' && crossAppNavigation === 'true') {
        // Try to navigate back to MOPUI login with logout parameter
        try {
          const mopuiUrl = window.location.port === '5174' ? 'http://localhost:5173' : window.location.origin;
          // Add logout parameter to signal MOPUI to clear its localStorage
          window.location.href = `${mopuiUrl}/auth/login?logout=true&source=MoceroUI`;
        } catch (error) {
          console.error('Failed to navigate to MOPUI login, using standalone login:', error);
          router.push({ path: "/login" });
        }
      } else {
        // Use standalone MoceroUI login
        router.push({ path: "/login" });
      }
    }

    const mystoremodel = ref([
      {
        label: "Options",
        items: [
          {
            label: "Home",
            icon: "pi pi-fw pi-home",
            to: "/",
          },
          {
            label: "Menu 1",
            icon: "pi pi-fw pi-bars",
            items: [
              {
                label: "Submenu 1-1",
                to: "/submenu1-1",
              },
              {
                label: "Submenu 1-2",
                to: "/submenu1-2",
              },
            ],
          },
          {
            label: "Menu 2",
            icon: "pi pi-fw pi-bookmark",
            items: [
              {
                label: "Submenu 2-1",
                to: "/submenu2-1",
              },
              {
                label: "Submenu 2-2",
                to: "/submenu2-2",
              },
            ],
          },
        ],
      },
    ]);
    let MainStoreList = ref({});
    let SubStoreList = ref({});
    let DepartmentStoreList = ref({});
    async function IsShow() {
      debugger;
      // const result = await commonservice.getStoreList();
      // console.log(result);
      // MainStoreList.value = result["result"].filter(
      //   (item) => item.StoreTypeName == "Main Store"
      // );
      // SubStoreList.value = result["result"].filter(
      //   (item) => item.StoreTypeName == "Sub Store"
      // );
      // DepartmentStoreList.value = result["result"].filter(
      //   (item) => item.StoreTypeName == "Department Store"
      // );
    }

    let ProfileData = ref({
      UserNameFirstLetter: "",
      UserName: "",
      RoleName: "",
      phoneNumber: "",
    });

    function LoadProfile() {
      debugger;
      ProfileData.value.UserNameFirstLetter = usersData.UserName.charAt(0);
      ProfileData.value.UserName = usersData.UserName;
      ProfileData.value.RoleName = rolesData.RoleName;
      ProfileData.value.phoneNumber = usersData.phoneNumber;
    }

    let SelectedBranchId = ref();

    let BranchDropDown: any = ref({
      BranchOption: [],
    });

    let SelectedRoleId = ref();

    let RoleDropDown: any = ref({
      RoleOption: [],
    });

    let BranchDropDownLength = ref();
    let RoleDropDownLength = ref();

    async function LoadProfileBranches() {
      debugger;
      const data_response = await LoginService.GetBranchesByUserId(
        usersData.UserId
      );
      console.log(data_response["result"]);

      BranchDropDownLength.value = data_response["result"].length;

      if (BranchDropDownLength.value != 1) {
        const allBranchIds = data_response["result"]
          .map((item) => item.BranchId)
          .join(",");

        data_response["result"].unshift({
          BranchId: allBranchIds,
          BranchName: "All",
          IsActive: true,
          HospitalBranchId: 0,
          HospitalBranchCode: "",
          BranchStateId: 0,
        });
      }


      BranchDropDown.value.BranchOption = data_response["result"].map(
        (item) => ({
          BranchName: item.BranchName,
          BranchId: item.BranchId,
          HospitalBranchId: item.HospitalBranchId,
          HospitalBranchCode: item.HospitalBranchCode,
          BranchStateId: item.BranchStateId,
        })
      );



      if (BranchDropDownLength.value == 1) {
        SelectedBranchId.value = {
          BranchName: data_response["result"][0].BranchName,
          BranchId: data_response["result"][0].BranchId,
          HospitalBranchId: data_response["result"][0].HospitalBranchId,
          HospitalBranchCode: data_response["result"][0].HospitalBranchCode,
          BranchStateId: data_response["result"][0].BranchStateId
        };
      } else {
        let BranchValue = BranchDropDown.value.BranchOption.filter(
          (x) => x.BranchId == usersData.BranchId
        );

        SelectedBranchId.value = {
          BranchName: BranchValue[0].BranchName,
          BranchId: BranchValue[0].BranchId,
          HospitalBranchId: BranchValue[0].HospitalBranchId,
          HospitalBranchCode: BranchValue[0].HospitalBranchCode,
          BranchStateId: BranchValue[0].BranchStateId,
        };
      }
    }

    let pendingrequestcount = ref();
    const LoadWorkList = async () => {
      let result = await ApprovalHistory.GetListByDeptRoleId(
        DeptRoleMapId.value
      );

      let branchIds = typeof usersData.BranchId === 'string' && usersData.BranchId.includes(',')
        ? usersData.BranchId.split(',')
        : [usersData.BranchId.toString()];

      entityitems.value = result["result"].filter(
        (x) =>
          branchIds.includes(x.BranchId.toString()) &&
          x.HospitalId == usersData.OrganizationId
      );

      console.log(entityitems.value);
      pendingrequestcount.value = entityitems.value.reduce(
        (total, item) => total + (item.ListCount || 0),
        0
      );
      console.log("Total ListCount:", pendingrequestcount.value);
    };

    const poapprovaltablecall = (data) => {
      router.push({
        name: "entitywiseApprovalTableView",
        query: {
          EntityId: data,
        },
      });
      entitymenu.value.toggle(false);
    };

    function BranchOnChange() {
      usersData.BranchId = SelectedBranchId.value.BranchId;
      localStorage.setItem("UsersData", JSON.stringify(usersData));
      router.push({
        path: "/Masters",
      });
      window.location.reload();
    }

    async function LoadprofileRoles() {
      debugger;
      const data_response = await LoginService.GetRolesByUserId(
        usersData.UserId,
        // SelectedBranchId.value.BranchId
        0
      );
      console.log(data_response["result"]);

      RoleDropDown.value.RoleOption = data_response["result"].map((item) => ({
        RoleName: item.RoleName,
        RoleId: item.RoleId,
        DeptRoleMapId: item.DeptRoleMapId,
      }));

      RoleDropDownLength.value = data_response["result"].length;

      if (RoleDropDownLength.value == 1) {
        SelectedRoleId.value = {
          RoleName: data_response["result"][0].RoleName,
          RoleId: data_response["result"][0].RoleId,
          DeptRoleMapId: data_response["result"][0].DeptRoleMapId,
        };
        RoleOnchange();
      } else {
        let RoleValue = RoleDropDown.value.RoleOption.filter(
          (x) => x.RoleId == rolesData.RoleId
        );

        SelectedRoleId.value = {
          RoleName: RoleValue[0].RoleName,
          RoleId: RoleValue[0].RoleId,
          DeptRoleMapId: RoleValue[0].DeptRoleMapId,
        };
      }
    }

    async function RoleOnchange() {
      debugger;

      let ModuleId = 1;

      let GetRightsResponse = await EntityMasterservice.GetRightsByRoleId(
        SelectedRoleId.value.RoleId,
        ModuleId
        // usersData.OrganizationId
      );
      console.log(GetRightsResponse);

      localStorage.removeItem("RolesData");

      let RolesData = {
        RoleId: SelectedRoleId.value.RoleId,
        RoleName: SelectedRoleId.value.RoleName,
        DeptRoleMapId: SelectedRoleId.value.DeptRoleMapId,
      };

      localStorage.setItem("RolesData", JSON.stringify(RolesData));

      ProfileData.value.RoleName = SelectedRoleId.value.RoleName;

      // let existingUsersData = localStorage.getItem("UsersData");
      // let usersData1;
      // if (existingUsersData !== null) {
      //   usersData1 = JSON.parse(existingUsersData);
      // }
      // usersData1.BranchId = SelectedBranchId.value.BranchId;
      // localStorage.setItem("UsersData", JSON.stringify(usersData1));

      if (RoleDropDownLength.value > 1) {
        router.push({
          path: "/Masters",
        });
        window.location.reload();
      }
    }

    function navigate(strId, storestatus) {
      router.push({
        name: "StoreTabDetails",
        query: {
          status: storestatus,
          Id: strId,
          Type: "StoreId",
        },
      });
      visibleLeft.value = false;
    }

    let ChangePasswordObjVal = ref({
      newpassword: "",
      confirmpassword: "",
    });

    let UserChangePasswordObjVal = ref({
      UserId: 0,
      Password: "",
    });

    const copyupdatepassword = JSON.parse(
      JSON.stringify(ChangePasswordObjVal.value)
    );

    const showError = ref(false);
    const IsStoreSubmit = handleSubmit(async (values) => {
      debugger;
      if (
        ChangePasswordObjVal.value.confirmpassword !==
        ChangePasswordObjVal.value.newpassword
      ) {
        showError.value = true;
      } else {
        showError.value = false;

        UserChangePasswordObjVal.value.UserId = usersData.UserId;

        UserChangePasswordObjVal.value.Password =
          ChangePasswordObjVal.value.confirmpassword;

        let response = await PasswordService.ChangePassword(
          UserChangePasswordObjVal.value
        );
        console.log(response["result"]);

        let msg = response["ErrorInfo"].ErrorCode;

        if (msg == null) {
          updatepop.value = true;
        } else {
          alert("Somthing went wrong");
        }
      }
    });

    function closetrigger() {
      updatepop.value = false;
      LogOut();
    }

    let showpass = ref(true);
    let showconfpass = ref(true);
    let showtxt = ref("Password");
    let showConfirmtxt = ref("Password");
    function showhide() {
      if (showpass.value == true) {
        showpass.value = false;
        showtxt.value = "text";
      } else {
        showpass.value = true;
        showtxt.value = "Password";
      }
    }
    function confirmshowhide() {
      debugger;
      if (showconfpass.value == true) {
        showconfpass.value = false;
        showConfirmtxt.value = "text";
      } else {
        showconfpass.value = true;
        showConfirmtxt.value = "Password";
      }
    }
    //Clear
    function IsClear() {
      debugger;
      Object.assign(ChangePasswordObjVal.value, copyupdatepassword);
    }


    // Module loading state
    const modules = ref<any[]>([]);
    const moduleLoading = ref(false);
    const moduleError = ref<string | null>(null);

    // Load available modules
    async function loadAvailableModules() {
      try {
        moduleLoading.value = true;
        moduleError.value = null;

        const response: any = await ModuleMaster.GetModulesByOrganizationId(usersData.OrganizationId);
        console.log("ModuleList", response.result);

        if (response && response.result) {
          // Map the API response to include proper icons, colors, and types
          modules.value = response.result.map((module: any) => ({
            ...module,
            icon: getModuleIcon(module.Name),
            color: getModuleColor(module.Name),
            type: getModuleType(module.Name)
          }));
        }
      } catch (error) {
        console.error('Error loading modules:', error);
        moduleError.value = 'Failed to load modules';
      } finally {
        moduleLoading.value = false;
      }
    }

    // Helper functions for module display
    function getModuleIcon(moduleName: string): string {


      const iconMap: { [key: string]: string } = {
        'Inventory': 'pi pi-box',
        'CRM': 'pi pi-users',
        'Billing': 'pi pi-money-bill',
        'User Management': 'pi pi-user-edit',
        'Communication': 'pi pi-comments',
        'Alert Engine': 'pi pi-bell'
      };
      return iconMap[moduleName] || 'pi pi-th-large';
    }

    function getModuleColor(moduleName: string): string {
      const colorMap: { [key: string]: string } = {
        'Inventory': '#4CAF50',
        'CRM': '#2196F3',
        'Billing': '#FF9800',
        'User Management': '#9C27B0',
        'Communication': '#00BCD4',
        'Alert Engine': '#F44336'
      };
      return colorMap[moduleName] || '#607D8B';
    }

    function getModuleType(moduleName: string): string {
      // Determine if module belongs to MOPUI or MoceroUI
      const moceroUIModules = ['Inventory', 'CRM', 'Billing', 'User Management', 'Communication', 'Alert Engine'];
      return moceroUIModules.includes(moduleName) ? 'MoceroUI' : 'MOPUI';
    }

    return {
      pendingrequestcount,
      entityitems,
      entitytoggle,
      entitymenu,
      showpass,
      showconfpass,
      showtxt,
      showConfirmtxt,
      showhide,
      confirmshowhide,
      routeto,
      MainStoreList,
      SubStoreList,
      DepartmentStoreList,
      navigate,
      mystore,
      mystoremodel,
      mystoretoggle,
      closesidebar,
      LogOut,
      menu,
      items,
      toggle,
      requestform,
      masters,
      visibleLeft,
      handleSelect(key: string | number) {
        alert(key);
      },
      generalOptions: listed.map((v) => ({
        label: v,
        value: v,
      })),

      active,
      value: valueRef,
      options: computed(() => {
        return ["@gmail.com", "@163.com", "@qq.com"].map((suffix) => {
          const prefix = valueRef.value.split("@")[0];
          return {
            label: prefix + suffix,
            value: prefix + suffix,
          };
        });
      }),

      name,
      ProfileData,
      SelectedRoleId,
      RoleDropDown,
      RoleOnchange,
      roleid,
      BranchDropDown,
      SelectedBranchId,
      BranchOnChange,
      Changepasswordpopup,
      IsClear,
      IsStoreSubmit,
      closetrigger,
      updatepop,
      ChangePasswordObjVal,
      showError,
      LoadWorkList,
      poapprovaltablecall,
      ModuleSwitcherpopup,
      modules,
      moduleLoading,
      moduleError,
      loadAvailableModules,
    };
  },
});
</script>
